// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"be4adecc","171":"67266e1c","238":"6c7aaf95","542":"970fc782"}[chunkId] + ".chunk.js";
};